module.exports = __webpack_public_path__ + "bt.17c8f1b2b0692eb296af.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bt.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bt.svg
// module chunks = styles